import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { FormProvider, Controller } from "react-hook-form";
import CheckBoxIcon from "@mui/icons-material/CheckBox.js";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank.js";
import TimerIcon from "@mui/icons-material/Timer.js";
import Box from "@mui/material/Box/index.js";
import Checkbox from "@mui/material/Checkbox/index.js";
import "lottie-react";
import { Avatar } from "../../../../../components/avatar/avatar.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import { DatePicker } from "../../../../../components/date-pickers/date-picker/date-picker.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import { Dialog } from "../../../../../components/dialog/dialog.js";
import "@mui/material";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import { TextField } from "../../../../../components/text-field/text-field.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import TimeIntervalSelect from "../../../../../components/time-interval-select/time-interval-select.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { DateIcon } from "../../../appointment-details/assets/icons/Date.js";
import { TitleIcon } from "../../../appointment-details/assets/icons/Title.js";
import { EmployeeAutocomplete } from "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.js";
import { useQueryClient } from "@tanstack/react-query";
import { getNameInitials } from "../../../../../utils/string/getNameInitials.js";
import { addTimezoneOffset } from "../../../../../utils/time/time.js";
import { format } from "date-fns";
import { de, enIE } from "date-fns/locale";
import { Language } from "../../appointment-schedule.types.js";
import { useBlockerForm } from "../../hooks/useBlockerForm.js";
import { useSaveBlocker } from "../../hooks/useSaveBlocker.js";
import { useWorkingTimesProvider } from "../../providers/working-times-provider.js";
import BlockerDeletionModal from "../blocker-deletion-modal/blocker-deletion-modal.js";
import { StyledFormControlLabel, InfoBox, InfoText } from "./blocker-modal.styles.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../../type/Translations.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "color-alpha";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../../../components/time-select/time-select.js";
import "@mui/material/InputAdornment/index.js";
import "@mui/material/Typography/index.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import "../../../../../components/time-select/time-select.hepers.js";
import "../../../../../components/time-interval-select/time-interval-select.helpers.js";
import "@mui/icons-material";
import "../../../appointment-details/assets/icons/Employee.js";
import "../../../appointment-details/helpers/common.js";
import "../../../appointment-details/appointment-details.types.js";
import "../../../appointment-details/hooks/useEmployeeSearch.js";
import "../../../appointment-details/providers/axios-provider.js";
import "axios";
import "../../../appointment-details/components/appointment-form/appointment-form.constants.js";
import "../../../appointment-details/components/appointment-form/appointment-form.helpers.js";
import "../../../appointment-details/helpers/appointment.js";
import "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.skeleton.js";
import "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.styles.js";
import "@hookform/resolvers/yup";
import "date-fns/startOfToday";
import "yup";
import "../../providers/axios-provider.js";
import "../../helpers/getViewTimePeriod.js";
import "../../appointment-schedule.constants.js";
import "../../helpers/getEmptyCalendarSlots.js";
import "../../helpers/groupBy.js";
import "lodash";
import "../../helpers/common.js";
import "fast-memoize";
import "../../helpers/fillEmptyDays.js";
import "../../hooks/useWorkingTimes.js";
import "../../hooks/useDeleteBlocker.js";
import "../blocker-deletion-modal/blocker-deletion-modal.styles.js";
import "@mui/material/FormControlLabel/index.js";
const LABEL_OFFSET = 50;
const BlockerModal = ({
  anchorEl,
  clinicReferenceId,
  employees,
  labels,
  blocker,
  language,
  onClose,
  onSaveBlocker,
  onDeleteBlocker
}) => {
  const queryClient = useQueryClient();
  const { form } = useBlockerForm(blocker);
  const { control } = form;
  const { queryKey: workingTimesQueryKey } = useWorkingTimesProvider();
  const { mutateAsync: saveBlocker } = useSaveBlocker(clinicReferenceId, async () => {
    if (workingTimesQueryKey) {
      await queryClient.invalidateQueries({ queryKey: workingTimesQueryKey });
    }
    onClose();
    onSaveBlocker == null ? void 0 : onSaveBlocker();
  });
  const [showDeletionModal, setShowDeletionModal] = useState(false);
  const [showForm, setShowForm] = useState(!(blocker == null ? void 0 : blocker.referenceId));
  const modalRef = useRef(null);
  const handleSave = async () => {
    const { employeeReferenceId, startDate, startTime, endTime, ...rest } = form.getValues();
    const blockerToSave = {
      ...blocker && { ...blocker },
      ...rest,
      employeeReferenceIds: [employeeReferenceId],
      startDate: format(startDate, DATE_FORMATS.ISO_SHORT),
      startTime: addTimezoneOffset(startTime),
      endTime: addTimezoneOffset(endTime)
    };
    await saveBlocker(blockerToSave);
  };
  const handleCancel = () => {
    setShowForm(false);
    setShowDeletionModal(!showForm);
  };
  const onDelete = () => {
    setShowDeletionModal(false);
    onClose();
    onDeleteBlocker == null ? void 0 : onDeleteBlocker();
  };
  const employee = (blocker == null ? void 0 : blocker.employeeReferenceIds.length) ? employees.find((employee2) => employee2.referenceId === (blocker == null ? void 0 : blocker.employeeReferenceIds[0])) : null;
  const getFormattedBlockerDuration = () => {
    if (!blocker) {
      return "";
    }
    const formattedDate = format(new Date(blocker.startDate), "EEEE, dd.MM.yyyy", {
      locale: language === Language.DEUTSCH ? de : enIE
    });
    return `${formattedDate}, ${blocker.startTime} - ${blocker.endTime}`;
  };
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      variant: showForm ? "default" : "error",
      title: showForm ? labels.modalTitle : blocker == null ? void 0 : blocker.description,
      subtitle: showForm ? "" : getFormattedBlockerDuration(),
      anchorEl,
      open: true,
      onClose,
      labels: {
        save: showForm ? labels.buttons.save : labels.buttons.edit,
        cancel: showForm ? labels.buttons.cancel : labels.buttons.delete
      },
      draggable: Boolean(anchorEl),
      width: showForm ? 680 : 480,
      ref: modalRef,
      onSave: showForm ? handleSave : () => setShowForm(true),
      onCancel: (blocker == null ? void 0 : blocker.referenceId) ? handleCancel : onClose,
      disableSave: showForm && !form.formState.isValid,
      disableClose: showDeletionModal,
      children: [
        showForm && /* @__PURE__ */ jsxs(FormProvider, { ...form, children: [
          /* @__PURE__ */ jsx(Box, { mb: 2, mt: 1, children: /* @__PURE__ */ jsx(
            Controller,
            {
              name: "description",
              control,
              render: ({ field: { ref, ...field }, fieldState: { error, isTouched } }) => {
                const showError = error && isTouched;
                return /* @__PURE__ */ jsx(
                  TextField,
                  {
                    ...field,
                    fullWidth: true,
                    label: labels.form.description.label,
                    inputRef: ref,
                    error: showError,
                    helperText: showError && labels.form.description.error,
                    labelOffset: LABEL_OFFSET,
                    required: true,
                    InputProps: {
                      startAdornment: /* @__PURE__ */ jsx(TitleIcon, {})
                    }
                  }
                );
              }
            }
          ) }),
          /* @__PURE__ */ jsx(Box, { mb: 2, children: /* @__PURE__ */ jsx(
            EmployeeAutocomplete,
            {
              employees,
              clinicReferenceId,
              labels: {
                noPreferredEmployee: labels.form.employee.noPreferredEmployee,
                label: labels.form.employee.label,
                error: labels.form.employee.error
              },
              isBlockerForm: true
            }
          ) }),
          /* @__PURE__ */ jsx(Box, { mb: 2, children: /* @__PURE__ */ jsx(
            Controller,
            {
              name: "startDate",
              control,
              render: ({ field: { value, ref, ...field }, fieldState: { error, isTouched } }) => {
                const showError = error && isTouched;
                return /* @__PURE__ */ jsx(
                  DatePicker,
                  {
                    ...field,
                    disablePast: true,
                    value,
                    closeOnSelect: false,
                    views: ["year", "month", "day"],
                    inputRef: ref,
                    reduceAnimations: true,
                    openTo: "day",
                    language,
                    format: DATE_FORMATS.DAY_MONTH_YEAR,
                    labels: {
                      cancelButtonLabel: labels.buttons.cancel,
                      okButtonLabel: labels.buttons.save
                    },
                    slotProps: {
                      popper: {
                        placement: "bottom-end"
                      },
                      textField: {
                        error: showError,
                        required: true,
                        label: labels.form.startDate.label,
                        // @ts-expect-error - missing type for labelOffset
                        labelOffset: LABEL_OFFSET,
                        InputProps: {
                          startAdornment: /* @__PURE__ */ jsx(DateIcon, {}),
                          onBlur: field.onBlur
                        },
                        fullWidth: true,
                        helperText: showError && labels.form.startDate.error
                      }
                    }
                  }
                );
              }
            }
          ) }),
          /* @__PURE__ */ jsx(
            TimeIntervalSelect,
            {
              startTimeName: "startTime",
              endTimeName: "endTime",
              labels: {
                startTime: labels.form.startTime,
                endTime: labels.form.endTime
              },
              required: true,
              mb: 3
            }
          ),
          /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
            Controller,
            {
              name: "workRelated",
              control,
              render: ({ field: { ...field } }) => /* @__PURE__ */ jsx(
                StyledFormControlLabel,
                {
                  label: labels.form.workRelated,
                  labelPlacement: "end",
                  control: /* @__PURE__ */ jsx(Checkbox, { checked: field.value, ...field })
                }
              )
            }
          ) })
        ] }),
        !showForm && !!(blocker == null ? void 0 : blocker.referenceId) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(InfoBox, { mt: 3, mb: 3, children: [
            /* @__PURE__ */ jsx(TitleIcon, {}),
            /* @__PURE__ */ jsx(InfoText, { variant: "Lato Body 1", children: blocker.description })
          ] }),
          /* @__PURE__ */ jsxs(InfoBox, { mb: 3, children: [
            /* @__PURE__ */ jsx(Avatar, { src: (employee == null ? void 0 : employee.imageUrl) ?? "", size: "s", children: getNameInitials(employee == null ? void 0 : employee.displayName) }),
            /* @__PURE__ */ jsx(InfoText, { variant: "Lato Body 1", children: employee == null ? void 0 : employee.displayName })
          ] }),
          /* @__PURE__ */ jsxs(InfoBox, { mb: 3, children: [
            /* @__PURE__ */ jsx(DateIcon, {}),
            /* @__PURE__ */ jsx(InfoText, { variant: "Lato Body 1", children: format(new Date(blocker.startDate), DATE_FORMATS.DAY_MONTH_YEAR) })
          ] }),
          /* @__PURE__ */ jsxs(InfoBox, { mb: 3, children: [
            /* @__PURE__ */ jsx(TimerIcon, {}),
            /* @__PURE__ */ jsxs(InfoText, { variant: "Lato Body 1", children: [
              blocker.startTime,
              " - ",
              blocker.endTime
            ] })
          ] }),
          /* @__PURE__ */ jsxs(InfoBox, { children: [
            /* @__PURE__ */ jsx(Fragment, { children: blocker.workRelated ? /* @__PURE__ */ jsx(CheckBoxIcon, {}) : /* @__PURE__ */ jsx(CheckBoxOutlineBlankIcon, {}) }),
            /* @__PURE__ */ jsx(InfoText, { variant: "Lato Body 1", children: labels.form.workRelated })
          ] })
        ] }),
        showDeletionModal && !!(blocker == null ? void 0 : blocker.referenceId) && /* @__PURE__ */ jsx(
          BlockerDeletionModal,
          {
            blocker,
            onCancel: () => setShowDeletionModal(false),
            onSave: onDelete,
            labels: labels.deletionDialog,
            language
          }
        )
      ]
    }
  );
};
BlockerModal.displayName = "BlockerModal";
export {
  BlockerModal as default
};
